import SelectorCursoMateria from "./SelectorCursoMateria.jsx";

function SincronizaMoodle(props) {
  const Cursos = Array.isArray(props?.Cursos?.Cursos)
    ? props.Cursos.Cursos.filter(Boolean)
    : [];

  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "20px",
        backgroundColor: "#fefefe",
        borderRadius: "10px",
        boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          marginBottom: "20px",
        }}
      >
        Aulas Moodle
      </h2>

      {Cursos.length > 0 ? (
        <SelectorCursoMateria Cursos={Cursos} />
      ) : (
        <div className="alert alert-warning text-center">
          No hay cursos disponibles para sincronizar con Moodle.
        </div>
      )}
    </div>
  );
}

export default SincronizaMoodle;